// Mitigate the benign "ResizeObserver loop completed with undelivered
// notifications." error.
//
// It fires when a ResizeObserver callback triggers layout changes that resize
// an observed element within the same frame — which happens continuously while
// dragging a resizable panel that contains the React Flow canvas. The error is
// harmless, but the dev error overlay surfaces it as a red screen.
//
// Fix strategy:
//   1) Defer observer callbacks to the next animation frame so the resize loop
//      is broken across frames (root-cause mitigation).
//   2) Swallow the specific benign messages so the dev overlay never shows them.

if (typeof window !== 'undefined') {
  const OriginalResizeObserver = window.ResizeObserver;
  if (OriginalResizeObserver && !OriginalResizeObserver.__patchedForLoopFix) {
    const Patched = class extends OriginalResizeObserver {
      constructor(callback) {
        super((entries, observer) => {
          window.requestAnimationFrame(() => {
            if (!Array.isArray(entries) || entries.length === 0) return;
            callback(entries, observer);
          });
        });
      }
    };
    Patched.__patchedForLoopFix = true;
    window.ResizeObserver = Patched;
  }

  const BENIGN_MESSAGES = [
    'ResizeObserver loop completed with undelivered notifications.',
    'ResizeObserver loop limit exceeded',
  ];
  const isBenign = (msg) => typeof msg === 'string' && BENIGN_MESSAGES.some((m) => msg.includes(m));

  window.addEventListener(
    'error',
    (e) => {
      if (isBenign(e.message)) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    },
    true,
  );
}
